export default "__VITE_ASSET__xSVOdKT9__"